export const galleryItems = [
  {
    id: "gal-001",
    titulo: "Mudanza residencial completa",
    descripcion: "Traslado de una vivienda de 4 ambientes con embalaje, carga y montaje final.",
    categoria: "mudanzas",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Moving%20crew%20loading%20wrapped%20furniture%20and%20labelled%20cardboard%20boxes%20into%20a%20white%20moving%20truck%20outside%20a%20bright%20modern%20house%2C%20clean%20minimal%20background%2C%20soft%20daylight%2C%20cool%20blue%20and%20white%20tones%2C%20documentary%20logistics%20photography&width=900&height=700&seq=axonia-gal-001&orientation=landscape",
    fecha: "2026-03-12",
    orden: 1,
    activo: true,
  },
  {
    id: "gal-002",
    titulo: "Traslado de oficina corporativa",
    descripcion: "Reubicación de mobiliario, equipos y archivo para una empresa de servicios.",
    categoria: "empresarial",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Office%20relocation%20with%20wrapped%20desks%2C%20chairs%20and%20filing%20boxes%20being%20loaded%20into%20a%20truck%20in%20a%20clean%20modern%20corporate%20building%2C%20minimal%20background%2C%20soft%20daylight%2C%20cool%20blue%20and%20white%20palette%2C%20professional%20photography&width=900&height=700&seq=axonia-gal-002&orientation=landscape",
    fecha: "2026-02-28",
    orden: 2,
    activo: true,
  },
  {
    id: "gal-003",
    titulo: "Acarreo de materiales de construcción",
    descripcion: "Transporte de insumos y materiales para una obra en la periferia de la ciudad.",
    categoria: "acarreos",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Cargo%20truck%20unloading%20construction%20materials%20and%20supplies%20at%20a%20bright%20construction%20site%20with%20clean%20minimal%20background%2C%20soft%20daylight%2C%20cool%20blue%20and%20grey%20tones%2C%20documentary%20industrial%20photography%2C%20high%20detail&width=900&height=700&seq=axonia-gal-003&orientation=landscape",
    fecha: "2026-02-14",
    orden: 3,
    activo: true,
  },
  {
    id: "gal-004",
    titulo: "Montaje de producción de evento",
    descripcion: "Transporte y descarga de sonido, iluminación y estructura para un evento masivo.",
    categoria: "eventos",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Event%20production%20crew%20unloading%20trusses%2C%20speakers%20and%20lighting%20equipment%20from%20a%20white%20van%20at%20an%20outdoor%20venue%2C%20clean%20minimal%20background%2C%20soft%20evening%20light%20with%20cool%20blue%20tint%2C%20professional%20photography&width=900&height=700&seq=axonia-gal-004&orientation=landscape",
    fecha: "2026-01-30",
    orden: 4,
    activo: true,
  },
  {
    id: "gal-005",
    titulo: "Distribución de última milla",
    descripcion: "Reparto diario de paquetes para una cadena de comercios en zona urbana.",
    categoria: "distribucion",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Delivery%20courier%20loading%20parcel%20boxes%20into%20a%20white%20van%20on%20a%20clean%20city%20street%2C%20minimal%20urban%20background%2C%20soft%20morning%20light%2C%20cool%20blue%20and%20white%20tones%2C%20professional%20editorial%20photography&width=900&height=700&seq=axonia-gal-005&orientation=landscape",
    fecha: "2026-01-18",
    orden: 5,
    activo: true,
  },
  {
    id: "gal-006",
    titulo: "Traslado de grupo corporativo",
    descripcion: "Movilización de colaboradores para una convención anual en otra ciudad.",
    categoria: "transporte",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Modern%20white%20coach%20bus%20with%20passengers%20boarding%20in%20front%20of%20a%20clean%20modern%20convention%20center%2C%20minimal%20background%2C%20soft%20daylight%2C%20cool%20blue%20tones%2C%20professional%20editorial%20transport%20photography&width=900&height=700&seq=axonia-gal-006&orientation=landscape",
    fecha: "2025-12-05",
    orden: 6,
    activo: true,
  },
  {
    id: "gal-007",
    titulo: "Mudanza de local comercial",
    descripcion: "Traslado de estanterías, mercadería y equipos de un local a una nueva sede.",
    categoria: "mudanzas",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Moving%20team%20carrying%20shelving%20units%20and%20merchandise%20crates%20into%20a%20white%20truck%20outside%20a%20clean%20modern%20retail%20store%2C%20minimal%20background%2C%20soft%20daylight%2C%20cool%20blue%20and%20white%20palette%2C%20professional%20photography&width=900&height=700&seq=axonia-gal-007&orientation=landscape",
    fecha: "2025-11-20",
    orden: 7,
    activo: true,
  },
  {
    id: "gal-008",
    titulo: "Suministro a cadena de tiendas",
    descripcion: "Ruta programada de abastecimiento para varias sucursales de una cadena minorista.",
    categoria: "distribucion",
    imagen_url:
      "https://readdy.ai/api/search-image?query=White%20box%20truck%20parked%20at%20a%20loading%20dock%20of%20a%20clean%20modern%20retail%20store%20with%20roll%20cages%20of%20stock%2C%20minimal%20background%2C%20soft%20daylight%2C%20cool%20blue%20and%20white%20tones%2C%20professional%20logistics%20photography&width=900&height=700&seq=axonia-gal-008&orientation=landscape",
    fecha: "2025-10-28",
    orden: 8,
    activo: true,
  },
  {
    id: "gal-009",
    titulo: "Servicio especial de carga sobredimensionada",
    descripcion: "Traslado de maquinaria de gran tamaño con permisos y escolta coordinada.",
    categoria: "acarreos",
    imagen_url:
      "https://readdy.ai/api/search-image?query=Heavy%20haulage%20truck%20transporting%20an%20oversized%20industrial%20machine%20on%20an%20open%20highway%20with%20escort%20vehicle%2C%20minimal%20clean%20background%2C%20soft%20daylight%2C%20cool%20blue%20and%20steel%20grey%20tones%2C%20professional%20industrial%20photography&width=900&height=700&seq=axonia-gal-009&orientation=landscape",
    fecha: "2025-10-02",
    orden: 9,
    activo: true,
  },
];